import { getEventTypeColorToken } from '@calendly/ui/utils/event-type-colors';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMeetingTracking } from 'features/meetings/hooks';
import type { Meeting } from 'features/meetings/types';
import { isExternalCalendarSource } from 'features/meetings/utils';
const contentRowActiveCss = "c1qdhmn3";
const contentRowSpotlightCss = "c1roz9uh";
const contentRowIsChildHoveredCss = "cjdwhr7";
const contentRowBrandRefreshCss = "c11a4wns";
const colorSwatchCss = "ce8q211";
const contentRowCss = "cao0uha";
interface MeetingCardLinkProps {
  event: Meeting;
  active?: boolean;
  spotlight?: boolean;
  isChildHovered?: boolean;
  isBrandRefresh?: boolean;
  linkPathname?: string;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  children: React.ReactNode;
}
export const MeetingCardLink = ({
  event,
  active,
  spotlight,
  isChildHovered,
  isBrandRefresh,
  linkPathname,
  onMouseEnter,
  onMouseLeave,
  children
}: MeetingCardLinkProps) => {
  const location = useLocation();
  const {
    trackViewDetails
  } = useMeetingTracking(event);
  const to = useMemo(() => {
    const params = new URLSearchParams(linkPathname ? '' : location.search);
    params.set('selected', event.uuid);
    params.delete('tab');
    const pathname = linkPathname ?? location.pathname;
    return `${pathname}?${params.toString()}`;
  }, [location.pathname, location.search, event.uuid, linkPathname]);
  const getSwatchColor = () => {
    if (isExternalCalendarSource(event.source)) return 'transparent';
    return getEventTypeColorToken(event.eventType?.color) ?? 'transparent';
  };
  return <Link to={to} onClick={trackViewDetails} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className={classNames(contentRowCss, {
    [contentRowActiveCss]: active,
    [contentRowSpotlightCss]: spotlight,
    [contentRowIsChildHoveredCss]: isChildHovered,
    [contentRowBrandRefreshCss]: isBrandRefresh
  })} {...isBrandRefresh && {
    style: {
      '--swatch-color': getSwatchColor()
    } as React.CSSProperties
  }}>
      {isBrandRefresh && <div data-testid="color-swatch" className={colorSwatchCss} />}
      {children}
    </Link>;
};

require("./MeetingCardLink.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MeetingCardLink.tsx");